import {WeaTools} from 'ecCom';
export default {
  logView : (params) =>WeaTools.callApi('/api/common/log/view', 'POST', params),
  viewDetail : (params) =>WeaTools.callApi('/api/common/log/viewdetail', 'GET', params),
};


// WEBPACK FOOTER //
// ./comMobx/wea-log-view/apis/Api.js